import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost,envAwareFormSubmit} from '../util/util'

export const getScheduledMessages = createAsyncThunk(
	'getScheduledMessages',
	async () => envAwarePost( 'api/messaging/api.php', {
		action: 'getScheduledMessages',
	})
)

export const deleteScheduledMessage = createAsyncThunk(
	'deleteScheduledMessage',
	async message_id => envAwarePost('api/messaging/api.php',{
		action: 'deleteScheduledMessage',
		message_id
	})
)

export const editScheduledMessage = createAsyncThunk(
	'editScheduledMessage',
	async payload => envAwareFormSubmit({
		path:'api/messaging/api.php',
		payload:{
			action: 'editScheduledMessage',
			...payload
		}
	})
)

const scheduledMessagesAdapter = createEntityAdapter()

const messengerSlice = createSlice({
	name: 'messenger',
	initialState:{
		editor:{
			show:false,
			status:'idle',
			//only matters if mode show is true
			messageId:null
		},
		scheduledMessages:scheduledMessagesAdapter.getInitialState()
	},
	reducers: {
		hideEditor: state => {
			state.editor.show = false
		},
		editMessage : (state,action) => {
			state.editor.show = true	
			state.editor.messageId = action.payload
		},
		newMessageScheduled : (state,action)=>{
			scheduledMessagesAdapter.addOne(state.scheduledMessages,action.payload)
		}
	},
	extraReducers:{
		[getScheduledMessages.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success === '1') scheduledMessagesAdapter.upsertMany(state.scheduledMessages,data)
		},
		[deleteScheduledMessage.pending] : (state,action)=>{
			const {arg:id} = action.meta
			scheduledMessagesAdapter.removeOne(state.scheduledMessages,id)
		},
		[editScheduledMessage.pending] : state => {
			state.editor.status = 'loading'
		},
		[editScheduledMessage.fulfilled] : (state,action)=>{
			state.editor.status = 'idle'
			const {success,data} = action.payload
			if(success === '1') scheduledMessagesAdapter.updateOne(state.scheduledMessages,{
				id:data.message.id,
				changes:data.message
			})
		}
	}
})

export const {
	newMessageScheduled,
	hideEditor,
	editMessage
} = messengerSlice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllScheduledMessages,
	selectById: selectScheduledMessageById,
	selectIds: selectScheduledMessagesIds
} = scheduledMessagesAdapter.getSelectors(state => state.messenger.scheduledMessages)


export default messengerSlice.reducer